var _a, _b, _c, _d, _e, _f, _g, _h;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import ApiService from '@/core/services/ApiService';
import msalWrapperClass from '@/core/services/SSOService';
import { UserInfo } from '@/core/types/entities/UserInfo';
const API_URLS = {
    getprofile: `${process.env.VUE_APP_BASE_URL_DIGITAL}/hr-usermanagement/api/user/getprofile`,
    loginInfo: `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_SHARED_GENERAL}/api/sessionlog/post`
};
let AuthModule = class AuthModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = [];
        this.role = '';
        this.user = {};
        this.isAuthenticated = false;
        this.token = '';
    }
    /**
     * Get current user object
     * @returns UserInfo
     */
    get currentUser() {
        return this.user;
    }
    get FCMToken() {
        return this.token;
    }
    [_a = Mutations.SET_USER_INFO](user) {
        this.user = user;
    }
    [_b = Mutations.PURGE_AUTH]() {
        this.isAuthenticated = false;
        this.user = {};
        this.errors = [];
    }
    [_c = Mutations.SET_FCM_TOKEN](token) {
        this.token = token;
    }
    [_d = Actions.LOGIN]() {
        return __awaiter(this, void 0, void 0, function* () {
            const wrapperInstance = msalWrapperClass.getInstance();
            const msalInstance = msalWrapperClass.getMSALInstance();
            yield wrapperInstance.getAccessTokenPopup(msalInstance);
            const account = wrapperInstance.getActiveUser(msalInstance);
            localStorage.setItem('account-info-cache', JSON.stringify(account));
        });
    }
    [_e = Actions.GET_PROFILE](payload) {
        const params = {
            upn: payload.account,
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.getprofile}?${new URLSearchParams(params).toString()}`)
                .then(({ data }) => {
                const result = data.result;
                if (result.content !== null) {
                    //NOTE - mapping to existing key for API getemployeeinformation
                    // to add, remove or change key object please contact General Team (Dharma Hermanda|Luhsita Gading|M. Ghazi Saragi)
                    const content = result.content;
                    let { roles } = content;
                    roles = roles || [];
                    const rolesIds = roles
                        .map((obj) => obj.roleId)
                        .join(',');
                    const rolesNames = roles
                        .map((obj) => obj.roleName)
                        .join(',');
                    const mappedObject = Object.assign(Object.assign({}, content), { 
                        /**Different keys with old one */
                        department: content.departmentName, empLevelID: content.employeeLevel, empLevelName: content.levelName, empName: content.employeeName, empStatusID: content.employmentStatus, empStatusName: content.employmentStatusName, genderID: content.gender, locationID: content.siteId, locationName: content.siteName, marital: content.maritalStatus, orgUnitID: content.organizationUnit, orgUnitName: content.organizationUnitName, pointOfHireID: content.pointOfHire, positionID: content.position, section: content.sectionName, roleId: rolesIds, roles: rolesNames });
                    this.context.commit(Mutations.SET_USER_INFO, mappedObject);
                    resolve(data.result.content);
                }
                else {
                    reject();
                }
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_f = Actions.LOGOUT]() {
        this.context.commit(Mutations.PURGE_AUTH);
        this.context.commit(Mutations.RESET_MENU_LIST);
    }
    [_g = Actions.LOGIN_INFO](payload) {
        return new Promise((resolve, reject) => {
            const newPayload = Object.assign(Object.assign({}, payload), { token: this.token, upn: this.user.email, nik: this.user.employeeID });
            ApiService.post(`${API_URLS.loginInfo}?ver=v1`, newPayload)
                .then(({ data }) => {
                resolve();
            })
                .catch(({ response }) => {
                reject();
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_h = typeof UserInfo !== "undefined" && UserInfo) === "function" ? _h : Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _c, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AuthModule.prototype, _d, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _g, null);
AuthModule = __decorate([
    Module
], AuthModule);
export default AuthModule;
